<app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent"> </app-brand-header>

<form  data-aci-speedpay role="form" [formGroup]="achForm">
  <main class="dsb-cards-container">
    <div class="dsb-card-wrapper">
      <div  class="dsb-card">

            <h3>Add Bank Account</h3>
    
            <div class="link-wrapper">
                <a href='/dsb-ocr' >Back to Available Funds</a>
            </div>
    
            <h2></h2>        

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>Account Type</label>
                                    <div class="input-group">
                                        <select formControlName="bank-account-type" data-aci-speedpay="bank-account-type" class="form-select" (change)="changeAccountType($event)">
                                            <!-- <option value="dummy">Choose account type</option> -->
                                            <option *ngFor="let accountType of accountTypes" [value]="accountType.code">{{accountType.literal}}</option>
                                        </select>
                                        <!-- <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faBriefcase"></fa-icon></span>
                                        </div> -->
                                    </div>
                                    <div *ngIf="!achForm.controls['bank-account-type'].valid && achForm.controls['bank-account-type'].dirty" class="alert alert-danger">
                                        Incorrect account type
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                          <div class="col-xs-12">
                              <div class="form-group">
                                  <label>Routing #</label>
                                  <div class="input-group">
                                      <input type="text" data-aci-speedpay="routing-number" formControlName="routing-number"
                                          pattern="^[0-9]{9}$"
                                          class="form-control" id="routing-number" placeholder="Routing Number" />
                                      <!-- <div class="input-group-append">
                                          <span class="input-group-text"><fa-icon [icon]="faUniversity"></fa-icon></span>
                                      </div> -->
                                  </div>
                                  <div *ngIf="!achForm.controls['routing-number'].valid && achForm.controls['routing-number'].dirty" class="alert alert-danger">
                                      Incorrect routing number
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col-xs-12">
                              <div class="form-group">
                                  <label>Account #</label>
                                  <div class="input-group">
                                      <input type="text" data-aci-speedpay="account-number" formControlName="account-number"
                                          pattern="^[0-9]{1,17}$"
                                          class="form-control" id="account-number" placeholder="Account Number" />
                                  <!-- <div class="input-group-append">
                                      <span class="input-group-text"><fa-icon [icon]="faCalendar"></fa-icon></span>
                                  </div> -->
                              </div>
                                  <div *ngIf="!achForm.controls['account-number'].valid && achForm.controls['account-number'].dirty" class="alert alert-danger">
                                      Incorrect account number
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col-xs-12">
                              <div class="form-group">
                                  <label>Name on Account</label>
                                  <div class="input-group">
                                      <input type="text" data-aci-speedpay="account-holder-name" formControlName="account-holder-name"
                                          minlength="1" maxlength="45"
                                          class="form-control" id="account-holder-name" placeholder="Account holder's name" />
                                      <!-- <div class="input-group-append">
                                          <span class="input-group-text"><fa-icon [icon]="faAddressCard"></fa-icon></span>
                                      </div> -->
                                  </div>
                                  <div *ngIf="!achForm.controls['account-holder-name'].valid && achForm.controls['account-holder-name'].dirty" class="alert alert-danger">
                                      Name on account must be provided
                                  </div>
                              </div>
                          </div>
                      </div>
 
                      <div class="row">
                          <div class="col-xs-12">
                              <div class="form-group">
                                  <label>Payment Nickname</label>
                                  <div class="input-group">
                                      <input type="text" data-aci-speedpay="funding-account-nickname" formControlName="funding-account-nickname"
                                          minlength="0" maxlength="45"
                                          class="form-control" placeholder="Enter payment nickname (optional)" id="funding-account-nickname" />
                                      <!-- <div class="input-group-append">
                                          <span class="input-group-text"><fa-icon [icon]="faCoffee"></fa-icon></span>
                                      </div> -->
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col-xs-12">
                              <div class="form-group">
                                  <label>Address</label>
                                  <div class="input-group">
                                      <input type="text" data-aci-speedpay="account-address-line1" formControlName="account-address-line1"
                                          minlength="0" maxlength="64"
                                          class="form-control" placeholder="Billing street address" id="account-address-line1" />
                                      <!-- <div class="input-group-append">
                                          <span class="input-group-text"><fa-icon [icon]="faHome"></fa-icon></span>
                                      </div> -->
                                  </div>
                                  <div *ngIf="!achForm.controls['account-address-line1'].valid && achForm.controls['account-address-line1'].dirty" class="alert alert-danger">
                                      Incorrect address provided
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col-xs-12">
                              <div class="form-group">
                                  <label>City</label>
                                  <div class="input-group">
                                      <input type="text" data-aci-speedpay="account-city" formControlName="account-city"
                                          minlength="0" maxlength="32"
                                          class="form-control" placeholder="Billing account city" id="account-city" />
                                      <!-- <div class="input-group-append">
                                          <span class="input-group-text"><fa-icon [icon]="faCity"></fa-icon></span>
                                      </div> -->
                                  </div>
                                  <div *ngIf="!achForm.controls['account-city'].valid && achForm.controls['account-city'].dirty" class="alert alert-danger">
                                      Incorrect city provided
                                  </div>
                              </div>
                          </div>
                      </div>

                      <div class="row">
                          <div class="col-sm-6 col-xs-12">
                              <div class="form-group">
                                  <label>State</label>
                                  <div class="input-group">
<!-- 
                                      <input type="text" data-aci-speedpay="account-region-code" formControlName="account-region-code"
                                          minlength="2" maxlength="3"
                                          class="form-control" id="account-region-code" placeholder="State Code" />
                                           -->
                                    <select formControlName="account-region-code" data-aci-speedpay="account-region-code" 
                                           class="form-select" id="account-region-code" placeholder="State Code" >
                                           <option *ngFor="let state of stateProvinces" [value]="state.stateCode">{{state.stateName}}</option>
                                    </select>
               
                                      <!-- <div class="input-group-append">
                                          <span class="input-group-text"><fa-icon [icon]="faBuilding"></fa-icon></span>
                                      </div> -->
                                  </div>
                                  <div *ngIf="!achForm.controls['account-region-code'].valid && achForm.controls['account-region-code'].dirty" class="alert alert-danger">
                                      <div *ngIf="true" severity="error">Incorrect state code</div>
                                  </div>
                              </div>
                          </div>

                          <div class="col-sm-6 col-xs-12">
                              <div class="form-group">
                                  <label>Zip Code</label>
                                  <div class="input-group">
                                      <input type="text" data-aci-speedpay="account-postal-code" formControlName="account-postal-code"
                                          minlength="5" maxlength="10"
                                          class="form-control" id="account-postal-code" placeholder="Postal Code" />
                                      <!-- <div class="input-group-append">
                                          <span class="input-group-text"><fa-icon [icon]="faEnvelopeOpen"></fa-icon></span>
                                      </div> -->
                                  </div>
                                  <div *ngIf="!achForm.controls['account-postal-code'].valid && achForm.controls['account-postal-code'].dirty" class="alert alert-danger">
                                      Incorrect postal code
                                  </div>
                              </div>
                          </div>
                      </div>

<!--                       
                      <div class="row">
                          <div class="col-xs-12">
                              <div class="form-check">
                                  <label class="form-check-label" for="single-use">SINGLE USE?</label>
                                  <input type="checkbox" data-aci-speedpay="single-use" class="form-check-input input-flex" formControlName="single-use" id="single-use" />
                              </div>
                          </div>
                      </div>
 -->


                <div class="dsb-card-footer">
                
                        <div class="button-wrapper">
                            <input type="button" data-aci-speedpay="ach-submit-button" class="dsb-sdk-button" id="ach-submit-button" value="Add Bank Account" [disabled]="!achForm.valid" />
                        </div>
                
                        <div class="link-wrapper">
                            <a href='/dsb-funding-accounts'>Cancel</a>
                        </div>

                        <div *ngIf="isDsbMessageShown" class="alert alert-warning alert-dismissible fade show" role="alert">
                            {{dsbMessage}}
                            <button type="button" class="btn-close" aria-lable="Close" (click)="closeDsbMessage()"></button>
                        </div> 

                
                </div>  <!-- dsb-card-footer -->
                


      </div>  <!-- dsb-card -->
<!-- 
      <div class="dsb-card-footer">

        <div class="button-wrapper dsb-center">
            <button [disabled]="!achForm.valid || showErrorMessage" data-aci-speedpay="ach-submit-button" id="ach-submit-button">Add Bank Account</button>
        </div>

        <div class="link-wrapper dsb-botttom">
            <a href='/dsb-funding-accounts'>Cancel</a>
        </div>        

      </div>   -->
    </div>    <!-- dsb-card-wrapper -->
  </main>
</form>



<!-- <div theme class="dsb-container"  [styleObj]='brandStyleTheme'>
    <div class="row">
        <div class="col-xs-12">
            <div class="panel panel-default">
                <div class="panel-heading">
                    <app-brand-header #header [brandProfile]="brandProfile" [pageContent]="pageContent"> </app-brand-header>
                </div>

                <form data-aci-speedpay role="form" [formGroup]="achForm">
                    <div class="panel-body">
                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>ROUTING NUMBER</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="routing-number" formControlName="routing-number"
                                            pattern="^[0-9]{9}$"
                                            class="form-control" id="routing-number" placeholder="Routing Number" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faUniversity"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!achForm.controls['routing-number'].valid && achForm.controls['routing-number'].dirty" class="alert alert-danger">
                                        Incorrect routing number
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>ACCOUNT TYPE</label>
                                    <div class="input-group">
                                        <select formControlName="bank-account-type" data-aci-speedpay="bank-account-type" class="form-control" (change)="changeAccountType($event)">
                                            <option value="dummy">Choose account type</option>
                                            <option *ngFor="let accountType of accountTypes" [value]="accountType.code">{{accountType.literal}}</option>
                                        </select>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faBriefcase"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!achForm.controls['bank-account-type'].valid && achForm.controls['bank-account-type'].dirty" class="alert alert-danger">
                                        Incorrect account type
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>ACCOUNT NUMBER</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-number" formControlName="account-number"
                                            pattern="^[0-9]{1,17}$"
                                            class="form-control" id="account-number" placeholder="Account Number" />
                                    <div class="input-group-append">
                                        <span class="input-group-text"><fa-icon [icon]="faCalendar"></fa-icon></span>
                                    </div>
                                </div>
                                    <div *ngIf="!achForm.controls['account-number'].valid && achForm.controls['account-number'].dirty" class="alert alert-danger">
                                        Incorrect account number
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>NAME ON ACCOUNT</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-holder-name" formControlName="account-holder-name"
                                            minlength="1" maxlength="45"
                                            class="form-control" id="account-holder-name" placeholder="Account holder's name" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faAddressCard"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!achForm.controls['account-holder-name'].valid && achForm.controls['account-holder-name'].dirty" class="alert alert-danger">
                                        Name on account must be provided
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>PAYMENT NICKNAME</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="funding-account-nickname" formControlName="funding-account-nickname"
                                            minlength="0" maxlength="45"
                                            class="form-control" placeholder="Enter payment nickname (optional)" id="funding-account-nickname" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faCoffee"></fa-icon></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>ADDRESS</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-address-line1" formControlName="account-address-line1"
                                            minlength="0" maxlength="64"
                                            class="form-control" placeholder="The billing address with the street address" id="account-address-line1" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faHome"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!achForm.controls['account-address-line1'].valid && achForm.controls['account-address-line1'].dirty" class="alert alert-danger">
                                        Incorrect address provided
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-group">
                                    <label>CITY</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-city" formControlName="account-city"
                                            minlength="0" maxlength="32"
                                            class="form-control" placeholder="The billing address with the city" id="account-city" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faCity"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!achForm.controls['account-city'].valid && achForm.controls['account-city'].dirty" class="alert alert-danger">
                                        Incorrect city provided
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-7">
                                <div class="form-group">
                                    <label>STATE</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-region-code" formControlName="account-region-code"
                                            minlength="2" maxlength="3"
                                            class="form-control" id="account-region-code" placeholder="State Code" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faBuilding"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!achForm.controls['account-region-code'].valid && achForm.controls['account-region-code'].dirty" class="alert alert-danger">
                                        <div *ngIf="true" severity="error">Incorrect state code</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-7">
                                <div class="form-group">
                                    <label>ZIP</label>
                                    <div class="input-group">
                                        <input type="text" data-aci-speedpay="account-postal-code" formControlName="account-postal-code"
                                            minlength="5" maxlength="10"
                                            class="form-control" id="account-postal-code" placeholder="Postal Code" />
                                        <div class="input-group-append">
                                            <span class="input-group-text"><fa-icon [icon]="faEnvelopeOpen"></fa-icon></span>
                                        </div>
                                    </div>
                                    <div *ngIf="!achForm.controls['account-postal-code'].valid && achForm.controls['account-postal-code'].dirty" class="alert alert-danger">
                                        Incorrect postal code
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-xs-12">
                                <div class="form-check">
                                    <label class="form-check-label" for="single-use">SINGLE USE?</label>
                                    <input type="checkbox" data-aci-speedpay="single-use" class="form-check-input input-flex" formControlName="single-use" id="single-use" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="panel-footer">
                        <div class="row">
                            <div class="btn-toolbar">
                                <input type="button" data-aci-speedpay="ach-submit-button" class="btn btn-submit" id="ach-submit-button" value="Submit" [disabled]="!achForm.valid || showErrorMessage" />
                                <button type="button" class="btn btn-cancel" (click)="onCancel()">Cancel</button>
                            </div>
                        </div>
                        <div class="row" *ngIf="showErrorMessage">
                            <div class="alert alert-danger" role="alert">
                                {{errorMessage}}
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
 -->
